<template>
	<v-col class="purchase-report">
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Laporan Pajak</div>
		</div>
		<div class="mt-5">
			<div class="d-flex flex-wrap justify-end py-2 px-5 mb-5 border rounded-lg" style="border: 1px solid #ccc;">
				<v-col cols="12" sm="12" md="6" lg="4" class="px-0 d-flex flex-row align-center justify-space-between">
					<label class="pr-5">Periode Tahun</label>
					<v-autocomplete
						placeholder="Pilih tahun periode"
						outlined
						dense
						background-color="white"
						class="rounded-xl date-no-border ml-5"
						no-data-text="Tidak ada data"
						color="primary"
						hide-details="auto"
						:items="yearList"
						v-model="params.year"
						@change="getData()">
					</v-autocomplete>
				</v-col>
			</div>

			<v-row>
				<v-col cols="12" class="py-0 py-sm-3">
					<div class="mt-4 mb-5" v-if="Object.keys(taxes).length > 0">
						<div class="font-size-12 secondary--text mb-5 font-weight-bold">Summary Pajak Anda Saat Ini</div>
						<!-- desktop version -->
						<div class="d-none d-md-flex flex-row align-center justify-center">
							<div class="d-flex flex-grow-1 flex-shrink-1 mr-2">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-10 font-weight-500"><span class="d-block font-weight-600">Total Komisi</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-14 font-weight-600 primary--text">{{ taxes.member_tax_income | toNumber }}</div>
									</div>
								</v-card>
							</div>

							<div class="d-flex flex-grow-1 flex-shrink-1 mr-2">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-10 font-weight-500"><span class="d-block font-weight-600">Komisi Kena Pajak</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-14 font-weight-600 primary--text">{{ taxes.member_tax_income_pkp | toNumber }}</div>
									</div>
								</v-card>
							</div>

							<div class="d-flex flex-grow-1 flex-shrink-1 mr-2">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-10 font-weight-500"><span class="d-block font-weight-600">Total Pajak</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-14 font-weight-600 primary--text">{{ taxes.member_tax_tax_value | toNumber }}</div>
									</div>
								</v-card>
							</div>

							<div class="d-flex flex-grow-1 flex-shrink-1 mr-2">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-10 font-weight-500"><span class="d-block font-weight-600">Persentase Pajak</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-14 font-weight-600 primary--text">{{ taxes.member_tax_max_percentage + '%' }}</div>
									</div>
								</v-card>
							</div>
						</div>

						<!-- mobile version -->
						<v-row class="ml-0 d-flex d-md-none">
							<v-col cols="6" sm="4" class="pl-0">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-10 font-weight-500"><span class="d-block font-weight-600">Total Komisi</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-14 font-weight-600 primary--text">{{ taxes.member_tax_income | toNumber }}</div>
									</div>
								</v-card>
							</v-col>

							<v-col cols="6" sm="4" class="pl-0">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-10 font-weight-500"><span class="d-block font-weight-600">Komisi Kena Pajak</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-14 font-weight-600 primary--text">{{ taxes.member_tax_income_pkp | toNumber }}</div>
									</div>
								</v-card>
							</v-col>

							<v-col cols="6" sm="4" class="pl-0">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-10 font-weight-500"><span class="d-block font-weight-600">Total Pajak</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-14 font-weight-600 primary--text">{{ taxes.member_tax_tax_value | toNumber }}</div>
									</div>
								</v-card>
							</v-col>

							<v-col cols="6" sm="4" class="pl-0">
								<v-card class="px-3 py-2 elevation-0 hover-shadow rounded-xl text-center d-flex flex-column align-stretch h-100 w-100" height="100">
									<div class="d-block cl-secondary font-size-10 font-weight-500"><span class="d-block font-weight-600">Persentase Pajak</span></div>
									<div class="d-flex flex-column align-center justify-center py-1">
										<div class="font-size-14 font-weight-600 primary--text">{{ taxes.member_tax_max_percentage | toNumber }}</div>
									</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</v-col>
			</v-row>

			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-3" v-if="!loading">
					<v-row v-if="Object.keys(taxes).length > 0">
						<v-col cols="12">
							<div class="font-size-12 secondary--text mb-0 font-weight-bold">Rincian Pajak Komisi</div>
						</v-col>

						<v-col cols="12" class="pt-0">
							<v-simple-table class="white-row table-vo table-history-bonus">
								<template v-slot:default>
									<thead class="font-size-10">
										<tr>
											<th class="text-left" width="25%">Tanggal</th>
											<th class="text-right" width="25%">Jumlah Komisi</th>
											<th class="text-right" width="25%">Komisi Kena Pajak</th>
											<th class="text-right" width="25%">Jumlah Pajak</th>
										</tr>
									</thead>
									<tbody class="grey--text text--darken-3">
										<tr v-for="(tax, idx) in taxes.member_tax_arr_data" :key="tax.date + '-' + idx">
											<td class="text-left">{{ tax.date | tanggaljam }}</td>
											<td class="text-right cl-dark-green font-weight-bold">{{ tax.income | toNumber }}</td>
											<td class="text-right cl-dark-green font-weight-bold">{{ tax.income_pkp | toNumber }}</td>
											<td class="text-right cl-dark-green font-weight-bold">{{ tax.tax_value | toNumber }}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
					<div class="mt-3" v-if="Object.keys(taxes).length == 0">
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
									<NoData></NoData>
									<div class="pt-3 text-center cl-secondary">Tidak ada data laporan pajak yang dapat ditampilkan</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</div>
			</v-scroll-x-reverse-transition>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			params: {
				year: ''
			},
			yearList: []
		}
	},

	computed: {
		...mapState('profil', ['taxes']),
	},
	methods: {
		...mapActions('profil', ['getTaxReport']),

		async generatePeriods() {
			let current = await new Date().getFullYear()
			let startDate = ['2022']
			let bfYear = await Array.from({ length: 1 }, (_, i) => (current - 1) + i);
			let afYear = await Array.from({ length: 14 }, (_, i) => new Date(startDate).getFullYear() + i);

			this.params.year = current
			this.yearList = await bfYear
			this.yearList = this.yearList.concat(afYear)
		},

		async getData() {
			this.loading = await true
			await this.getTaxReport(this.params.year)
			
			setTimeout(() => {
				this.loading = false
			}, 1000);
		},
	},
	async mounted(){
		this.$store.dispatch('setPageTitle', `Laporan Pajak`)
		let current = await new Date().getFullYear()
		this.params.year = await current
		this.getData()
		this.generatePeriods()
	}
};
</script>